import React from 'react';
import Button from './button';
import style from './headerAbout.module.css';
import Img from 'gatsby-image';
import "normalize.css"


const HeaderAbout = ({ section }) => {
  const { overline, title, body1, images } = section;
  return (
    <section className={style.headerAboutWrapper}>
      <div className={style.headerAboutFirst}>
        <h6 className="font-caption">{overline}</h6>
        <h3>{title}</h3>

        <Button title="Download app" type="secondary" link="/getapp?redirect" />

        <p>{body1}</p>

        <div>
          <img src="/images/CelineImage.jpg" alt="ceo-image" />

          <span>
            <span className="button-1">Celine Fierro</span>
            <br />
            <span className="bodytext-2">CEO at OhCleo</span>
          </span>
        </div>
      </div>
      <div className={style.headerAboutSecond}>
        <Img
          fluid={images[0].fluid}
          alt={'App promo'}
          css={{ borderRadius: '6px' }}
        />
        {/* <img src="images/aboutHeader.png" alt="header-image" /> */}
      </div>
    </section>
  );
};

export default HeaderAbout;
